export enum LocaleEnumFe {
  csCZ = 'cs-CZ',
  enUs = 'en-US',
  skSK = 'sk-SK',
  enGB = 'en-GB',
}
